export class InvalidActionTransitionError extends Error {
  constructor(
    public readonly status: string,
    public readonly targetStatus: string,
  ) {
    super(`Action cannot be transitioned from ${status} to ${targetStatus}`);
  }
}
